var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tg4-button",class:(_vm.primary ? 'primary' : '') + (_vm.large ? ' large' : ''),attrs:{"id":_vm.id,"tabindex":"0"}},[_vm._v(" "+_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }